'use client'

import React, { useState } from 'react'

import whereToWatchStyle from '../../styles/components/homePage/where_to_watch.js'

const Platform = ({ platform, className }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <>
      {/* ID and className attributes in line below needed for GA analytics */}
      <a
        href={platform?.url}
        target='_blank'
        rel='noreferrer'
        id={platform?.name}
        className={`platform-link ${className}`}>
        <div
          className='platform'
          data-testid='platform'
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            backgroundColor: isHovered ? platform?.backgroundColorHover : platform?.background
          }}>
          <img src={isHovered ? platform?.logoHover : platform?.logo} alt={platform?.logoTitle} />
          <img style={{ display: 'none' }} src={platform?.logoHover} />
        </div>
      </a>
      <style jsx>{whereToWatchStyle}</style>
    </>
  )
}

export default Platform
